"use client";

import Link from "next/link";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { Home } from "lucide-react";

export default function NotFound() {
  return (
    <div
      className={cn(
        "min-h-screen flex items-center justify-center -mt-24",
        "bg-background text-foreground"
      )}
    >
      <div className="max-w-2xl mx-auto px-4">
        <div className="rounded-2xl text-center flex flex-col items-center justify-center">
          <h1
            className={cn(
              "text-6xl sm:text-[12rem] font-semibold text-center mb-4",
              "text-foreground/90 tabular-nums"
            )}
          >
            404
          </h1>

          <h2 className="text-2xl sm:text-3xl font-bold text-foreground mb-3">
            Page Not Found
          </h2>

          <p className="text-muted-foreground mb-8 max-w-md mx-auto">
            The page you&apos;re looking for doesn&apos;t exist or has been
            moved.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button
              variant="default"
              size="lg"
              className="rounded-full"
              render={
                <Link href="/">
                  <Home className="size-4 mr-2" aria-hidden />
                  Back to Home
                </Link>
              }
            />
          </div>
        </div>

        <div className="mt-6 text-center">
          <p className="text-sm text-muted-foreground">
            Need help? Contact support or return to the homepage.
          </p>
        </div>
      </div>
    </div>
  );
}
